module.exports = __webpack_public_path__ + "img/news-trends@2x.e545200c.png";